import { generalMessages } from 'src/utils/messages';
import { LANGUAGE, PAYMENT_PROVIDER } from 'src/features/customers/utils/types';
import { customersMessages } from 'src/features/customers/utils/messages';

export const LANGUAGE_TRANSLATION_MAP : Record<LANGUAGE, {id: string, defaultMessage: string}> = {
    [LANGUAGE.BULGARIAN]: generalMessages.bulgarian,
    [LANGUAGE.ENGLISH]: generalMessages.english,
};

export const PAYMENT_PROVIDER_TRANSLATION_MAP : Record<PAYMENT_PROVIDER, {id: string, defaultMessage: string}> = {
    [PAYMENT_PROVIDER.MANUAL]: customersMessages.manual,
    [PAYMENT_PROVIDER.AUTOMATIC]: customersMessages.automatic,
};